import React, { Component } from "react";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";

export default class RadioButtons extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(value, productAttribute) {
        // unselect all radio button, and disable add to cart, add tooltip
        $(".wireless-plan-button").addClass("disabled-button");
        $(".wireless-button-container").attr("data-tooltip", I18n.t("dataPlans.tooltip"));
        $(".wireless-radio").prop("checked", false);

        const { product } = this.props;
        const productAttributeId = productAttribute.productAttributeId;
        const productAttributeMapId = value.productAttributeMappingId;
        const attributeValueId = value.id;
        const productAttributePrice = value.priceAdjustmentValue;
        const optionClicked = {
            productAttributeId,
            productAttributeMapId,
            attributeValueId,
            productAttributePrice
        };
        this.props.selectOption(optionClicked);
        // check the radio button of the one selected
        $("#wireless-radio-" + value.id).prop("checked", true);

        // remove disable class from Select Plan button once a selection is made from radio list
        $(".wireless-btn-" + product.id).removeClass("disabled-button");
        // remove button tool tip once a selection is made from radio list
        $(".tooltip-wrapper-" + product.id).removeAttr("data-tooltip");
    }

    render() {
        const { productAttribute } = this.props;
        const values = productAttribute.values;
        // filter out the 250mb data plans so they cant be added to cart
        // would normally do this by product id, but the plan attributes have different ids for 250 mb plans so its being done by name
        const filteredPlans = _.reject(values, ["name", "250 MB"]);
        
        if (values.length > 0) {
            return _.map(filteredPlans, value =>
                <div className="radio" key={value.id}>
                    <label>
                        <input type="radio" name="planValue" value="" className="wireless-radio" id={`wireless-radio-${value.id}`} onClick={() => {
                            this.onClick(value, productAttribute);
                        }} />{value.name} - {value.priceAdjustment} <Translate value="misc.month" />
                    </label>
                </div>
            );
        }

        return "";
    }
}